import { UserManager } from "oidc-client";
import getUrl from "../utility/getUrl";

class AuthenticationWorker {
  constructor() {
    this.mgr = null;
    this.identityServerSettings = null;
    this.currentOrganizationId = null;
    this.accessTokenSessionStorageKey = "access_token";
    this.signInCalledSessionStorageKey = "sign-in-called";

    this.callbackUserLoggedIn = undefined;

    this.init();
  }

  async init() {
    const accessToken = sessionStorage.getItem(this.accessTokenSessionStorageKey);
    if (accessToken !== null) {
      this.createUserManager();
      if (this.mgr !== null) {
        const user = await this.mgr.getUser();
        if (user) {
          this.signinUser(user);
        }
      }
    }
  }

  handleUserLoggedIn(callback) {
    this.callbackUserLoggedIn = callback;
  }

  setUserLoggedIn(userToken, user) {
    if (this.callbackUserLoggedIn) {
      this.callbackUserLoggedIn(userToken, user);
    }
  }

  signin() {
    if (this.mgr === null) {
      this.createUserManager();
    }

    if (this.mgr) {
      this.mgr.signinRedirect();
    }
  }

  signout() {
    if (this.mgr) {
      this.mgr.signoutRedirect();
    }

    // clean
    sessionStorage.removeItem(this.idTokenSessionStorageKey);
    sessionStorage.removeItem(this.accessTokenSessionStorageKey);
    this.setUserLoggedIn();

    this.setCurrentOrganizationId(null);
    sessionStorage.setItem(this.signInCalledSessionStorageKey, "false");
  }

  createUserManager() {
    try {
      if (!this.mgr) {
        this.identityServerSettings = {
          authority: getUrl("identityServiceServer"),
          client_id: "Dashboard",
          redirect_uri: `${window.location.origin}/signin`,
          post_logout_redirect_uri: `${window.location.origin}/signout`,
          silent_redirect_uri: `${window.location.origin}/silent-renew`,
          automaticSilentRenew: true,
          response_type: "code",
          scope: "openid profile auth ProjectViewerService MgmtService LandingPageService DashboardService OrganizationApi",
        };

        if (this.currentOrganizationId) {
          this.identityServerSettings["acr_values"] = `organization:${this.currentOrganizationId}`;
        }
        this.mgr = new UserManager(this.identityServerSettings);
        // signed out event handling
        this.mgr.events.addUserSignedOut(() => {
          this.signout();
        });

        // user signed in event handling
        this.mgr.events.addUserLoaded(() => {
          this.mgr.getUser().then((loadedUser) => {
            sessionStorage.setItem(this.idTokenSessionStorageKey, loadedUser.id_token);
            sessionStorage.setItem(this.accessTokenSessionStorageKey, loadedUser.access_token);
          });
        });

        this.mgr.events.addUserUnloaded(function (e) {
          console.log("user unloaded");
        });
        this.mgr.events.addAccessTokenExpiring(function () {
          console.log("Access token expiring.");
        });
        this.mgr.events.addAccessTokenExpired(function () {
          console.log("Access token has expired");
        });
        this.mgr.events.addSilentRenewError(function () {
          console.log("Automatic silent renew has failed.");
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  onSigninSlientCallback() {
    if (this.mgr) {
      return this.mgr.signinSilentCallback();
    }
  }

  onCallback(callbackLoggedIn) {
    if (this.mgr === null) {
      this.createUserManager();
    }

    return this.mgr.signinRedirectCallback().then(
      (user) => {
        this.signinUser(user, callbackLoggedIn);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  async signinUser(user, callbackLoggedIn) {
    const idToken = JSON.parse(window.atob(user.id_token.split(".")[1]));
    const sub = idToken.sub;
    const organizationId = idToken.organization_id;
    const access_token = user.access_token;
    this.currentOrganizationId = organizationId;
    sessionStorage.setItem(this.accessTokenSessionStorageKey, user.access_token);

    if (callbackLoggedIn) {
      callbackLoggedIn(user);
    }

    // ask management service for user information
    //const urlUser = `${getUrl("userManagementServiceServer")}/app/users/${sub}/${organizationId}/information`;
    const urlUser = `${getUrl("organizationApi")}/v1.0/organizations/${organizationId}/users/${sub}`;
    console.log(urlUser);
    const requestOptions = {
      headers: new Headers({
        Authorization: `Bearer ${access_token}`,
      }),
    };

    const userData = await fetch(urlUser, requestOptions)
      .then((res) => res.json())
      .catch((err) => {
        console.log("Error:", err);
      });
    this.setUserLoggedIn(user, userData);
  }

  render() {
    return null;
  }
}

let authenticationWorker = undefined;

function initAuthenticationWorker() {
  authenticationWorker = new AuthenticationWorker();
}

const getAuthenticationWorker = () => {
  return authenticationWorker;
};

export default getAuthenticationWorker;

export { initAuthenticationWorker };
